export const FOOTER_LOGO = `${process.env.PUBLIC_URL}/assets/logo/transparent.png`;

export const FOOTER_BRAND = 'Safinah Al Sama';

export const FOOTER_SLOGAN =
  'Your trusted logistics & customs partner across the UAE & GCC.';

export const QUICK_LINKS = [
  { name: 'About', id: 'about-section-container' },
  { name: 'Services', id: 'service-container' },
  { name: 'Contact', id: 'contact-container' },
];